const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

const storage = {
    saveToken(accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    },

    getToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    },

    removeToken() {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    },


    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    saveItem(name, data){
        localStorage.setItem(name, data);
    },

    getItem(name){
        return localStorage.getItem(name);
    },

    clear(){
        localStorage.clear();
    }

};

export default storage